import { AsyncStoreItem } from '@lib/store';
import { GetReceiptResponse } from 'src/sdk-servicing';

/**
 * GetReceipt model
 */
export interface GetReceiptModel {
  model: GetReceiptResponse | null;
}

/**
 * GetReceiptResponse model details
 */
export interface GetReceiptStateDetails extends AsyncStoreItem {}

/**
 * GetReceipt store state
 */
export interface GetReceiptState extends GetReceiptStateDetails, GetReceiptModel {}

/**
 * Name of the GetReceipt Store
 */
export const GET_RECEIPT_STORE_NAME = 'getReceipt';

/**
 * GetReceipt Store Interface
 */
export interface GetReceiptStore {
  /** GetReceipt state */
  [GET_RECEIPT_STORE_NAME]: GetReceiptState;
}
